import { ApolloQueryResult, useQuery } from '@apollo/client';

import { ProviderLicensesDocument } from '@/store/v2';
import { HookResult } from '@/store/apolloClient';
import { Provider } from '@/store/providers';
import { Realm } from '@/types/realm';

interface ProviderLicensesSummary {
  id: number;
  pendingLicenses: number;
}

interface ProviderLicensesSummaryQuery {
  realmProviderLicensesSummary?: ProviderLicensesSummary;
}

interface ProviderLicensesSummaryResponse extends HookResult {
  loading: boolean;
  data?: ProviderLicensesSummary;
  refetch: () => Promise<ApolloQueryResult<ProviderLicensesSummaryQuery>>;
}

export const useProviderLicensesSummary = (provider: Provider, realm: Realm = window.realm): ProviderLicensesSummaryResponse => {
  const { data, loading, networkStatus, error, refetch } = useQuery<ProviderLicensesSummaryQuery>(ProviderLicensesDocument, {
    variables: { provider, realm },
  });
  return { data: data?.realmProviderLicensesSummary, loading, networkStatus, error, refetch };
};
